export default "__VITE_ASSET__08d8acc8__"